var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokOscuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 29C22.5081 29 29 22.5081 29 14.5C29 6.49187 22.5081 0 14.5 0C6.49187 0 0 6.49187 0 14.5C0 22.5081 6.49187 29 14.5 29ZM20.8879 6.65854C21.666 7.53656 22.7035 8.14256 23.8493 8.38819C24.2277 8.46818 24.6134 8.50826 25.0001 8.50778V12.4437C23.0365 12.4472 21.1213 11.8335 19.5239 10.689V18.7219C19.5238 20.1685 19.0936 21.5823 18.2881 22.7828C17.4827 23.9833 16.3386 24.916 15.0018 25.4619C13.6651 26.0078 12.1963 26.1421 10.7831 25.8476C9.36983 25.5532 8.07618 24.8434 7.06726 23.8088C6.00929 22.7234 5.3163 21.3338 5.08521 19.8343C4.85413 18.3347 5.0965 16.8003 5.77843 15.4456C6.46036 14.0909 7.54774 12.9837 8.88848 12.2789C10.2292 11.5741 11.7563 11.3069 13.256 11.5146V15.5391C12.5834 15.3246 11.8602 15.3305 11.1912 15.5557C10.5222 15.7809 9.9421 16.2139 9.53514 16.7918C9.12818 17.3696 8.91547 18.0624 8.92785 18.7696C8.94024 19.4768 9.17707 20.1617 9.60402 20.7249C10.0244 21.2789 10.6075 21.6869 11.2712 21.8916C11.9349 22.0964 12.646 22.0875 13.3045 21.8664C13.9629 21.6452 14.5357 21.2229 14.9423 20.6587C15.3489 20.0944 15.5689 19.4167 15.5713 18.7207V3H19.5239V3.50708C19.6319 4.67638 20.1098 5.78052 20.8879 6.65854Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokOscuro);
export default __webpack_public_path__ + "static/media/tiktok_oscuro.0e37ba6353e02a391105a2478eed240e.svg";
export { ForwardRef as ReactComponent };